var render = function (_h,_vm) {var _c=_vm._c;return _c('h3',{staticClass:"cy-base-subheader text-h6 text-uppercase grey lighten-2 px-4 mb-5",staticStyle:{"margin-top":"56px"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }